export const CONTACT_METHOD_LABEL_BY_KEY = Object.freeze({
    text: "Text",
    phone: "Phone",
    email: "Email",
})

/**
 * @param {unknown} value
 * @returns {string}
 */
export function formatContactMethodLabel(value) {
    const key = value != null ? String(value).toLowerCase().trim() : ""
    return CONTACT_METHOD_LABEL_BY_KEY[key] ?? ""
}

